import {
  GETREFUNDDETAILSPARTNER_SUCCESS,
  GETREFUNDDETAILSPARTNER_FAILED,
  LOADING_GETREFUNDDETAILSPARTNER,
  NETWORK_ERROR_GETREFUNDDETAILSPARTNER,
  RESET_GETREFUNDDETAILSPARTNER,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetPartnerGetRefundDetails = () => {
  return { type: RESET_GETREFUNDDETAILSPARTNER };
};

const partnerGetRefundDetails = (userData, authTokenIs) => async (dispatch) => {
  dispatch({ type: LOADING_GETREFUNDDETAILSPARTNER });
  await partnerServices
    .post("getRefundDetails", userData, {
      headers: { AuthToken: authTokenIs },
    })
    .then((res) => {
      switch (res.data.status) {
        case "success":
          dispatch({
            type: GETREFUNDDETAILSPARTNER_SUCCESS,
            payload: res.data,
          });
          break;
        default:
          dispatch({ type: GETREFUNDDETAILSPARTNER_FAILED, payload: res.data });
          break;
      }
    })
    .catch((err) => {
      dispatch({
        type: NETWORK_ERROR_GETREFUNDDETAILSPARTNER,
        payload: err,
      });
    });
};

export { partnerGetRefundDetails, resetPartnerGetRefundDetails };
